import { DetailAction } from '../../detail/actions/DetailAction';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { FilterState, listFilterType } from '../../../pages/content/listPage/FilterState';
import { EpgUtil } from '../../utility/EpgUtil';
import { Backend } from '../../../api/Backend';
import { ChannelModel } from '../../../api/EpgApi.types';
import { OptionData } from '../../../components/option/OptionData';
import { ChannelManager } from '../../../api/ChannelManager';
import { EpgApiV5 } from '../../../api/EpgApiV5';
import { ListTranslationKeys } from '../../../api/models/TranslationKeys';

export class ListChannelFilterActionHandler extends DetailAction {
  private filterState: FilterState;
  private readonly filterSubscription: (type: string, value: OptionData) => void;
  private channelsList: ChannelModel[] | undefined;

  constructor(backend: Backend, filterState: FilterState) {
    super(backend);
    this.filterState = filterState;
    this.filterSubscription = this.filterStateChanged.bind(this);
    this.filterState.subscribe(this.filterSubscription);
  }

  override doAction() {
    this._getChannelsList().then(channels => {
      const options = channels.map(channel => ({
        text: channel.text.title,
        value: channel,
      }));

      this.owner?.fireAncestors('$openDialog', {
        type: SelectOptionDialog,
        params: {
          backend: this._backend,
          options: options,
          onSuccess: (val: OptionData) => {
            this.optionSelected(val);
          },
          onCancelled: this.hideOptions.bind(this),
          noContentMessage: this._backend.translations.forKey(ListTranslationKeys.error_filter_no_channel_for_filter),
        },
      });
    });
  }

  _getChannelsList(): Promise<ChannelModel[]> {
    if (this.channelsList) return Promise.resolve(this.channelsList);

    //todo replay
    const filterState = this.filterState.state;
    const fromUntil = EpgUtil.fromUntilFromTime(filterState.date ?? new Date(), false);
    return ChannelManager.validChannels(this._backend, false).then(channels => {
      return EpgApiV5.channelFilter(this._backend, fromUntil.from, fromUntil.until).then(channelIds =>
        channels.validChannels.filter(channel => channelIds.includes(channel.channelId))
      );
    });
  }

  optionSelected(option: OptionData) {
    this.filterState.updateState(listFilterType.channel, option.value.text.title, option.value);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }

  filterStateChanged(_type: string, _value: OptionData) {
    // Do not update channelList when changing type or accessibility
    // NEBINT-14116 see comment / parent ticket
    // //if it's a tag, day, or accessibility update => update the channellist
    // if (
    //   type === listFilterType.tag ||
    //   type === listFilterType.day ||
    //   type === listFilterType.accessibility ||
    //   type === listFilterType.all
    // ) {
    //   this.channelsList = undefined;
    // }
  }
}
